/* ---------------------------------------------------------------------------
   Subir del todo.

   Con cinco hojas cargadas la biblioteca pasa de los treinta mil píxeles de
   alto —unas treinta y cinco pantallas—. Este botón aparece en cuanto se ha
   bajado un par de pantallas y devuelve al principio de un clic.

   Se mira la posición del scroll, no un vigía de intersección: el vigía es más
   barato sobre el papel, pero solo avisa cuando el navegador quiere y hay
   entornos donde no llega a avisar nunca. Un botón de subir que a veces no
   aparece no sirve de nada. El coste se controla haciendo la cuenta una vez por
   fotograma, no una por cada píxel que se mueve.

   Sin este fichero no hay botón y no pasa nada más.
   --------------------------------------------------------------------------- */
(() => {
  if (window.__lvCargados && window.__lvCargados.has('lv-arriba')) return;
  (window.__lvCargados = window.__lvCargados || new Set()).add('lv-arriba');

  const boton = document.querySelector('[data-lv-arriba]');
  if (!boton) return;

  // La cuenta va directa en el escuchador, sin pasar por un fotograma.
  //
  // Lo normal sería agrupar con requestAnimationFrame para no hacer trabajo de
  // más, pero hay entornos donde ese fotograma no llega nunca y entonces el
  // botón no aparece jamás. Y lo que se ahorraba era una comparación de dos
  // números: el navegador ya limita los avisos de scroll a uno por fotograma.
  const mirar = () => {
    boton.hidden = window.scrollY < window.innerHeight * 1.5;
  };

  window.addEventListener('scroll', mirar, { passive: true });

  // Sube de golpe, no con animación: sobre treinta mil píxeles, un
  // desplazamiento suave o tarda una eternidad o el navegador lo descarta a
  // mitad. Un salto seco es además lo que la gente espera de este botón.
  boton.addEventListener('click', () => {
    window.scrollTo(0, 0);
  });

  mirar();
})();
